import { CognitoUserPool } from "amazon-cognito-identity-js";
import constants from "../../constants";

const { CognitoUserPoolId, CognitoClientId } = constants.aws;

export default new CognitoUserPool({
  UserPoolId: CognitoUserPoolId,
  ClientId: CognitoClientId,
});
